<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters v-model="filterOptions" style="margin-right: 45px" @click="refresh" />
            <DropdownColumns v-model="fields" class="customize" />
          </div>
          <b-table
            id="third-party-players-table"
            :busy.sync="isBusy"
            show-empty
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :hover="true"
            :striped="true"
            stacked="md"
            :items="provider"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            @row-clicked="rowClicked"
            tbody-tr-class="tr-pointer"
            v-columns-resizable="{afterResize: columnsWidthChanged}"
          > <!-- REMOVED v-model="copy" -->

            <template v-slot:empty="scope">
              <div class="text-center">{{ $t(scope.emptyText) }}</div>
            </template>

            <template v-slot:head(etenant_id)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(eshop_id)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(name)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(surname)="data">{{ $t(data.label) }}</template>
            <!--
            <template v-slot:head(cnp)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(blacklisted)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(app_id)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(euser_id)="data">{{ $t(data.label) }}</template>

            <template v-slot:cell(euser_id)="data">
              <span v-if="data.value">
                <span v-if="data.value.to">
                  <router-link :to="`/users/${data.value.to}`">{{ data.value.name }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </span>
            </template>
            <template v-slot:cell(app_id)="data">
              <span v-if="data.value">
                <span v-if="data.value.to">
                  <router-link :to="`/shops/${data.value.to}`">{{ data.value.name }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </span>
            </template>
            -->
            <template v-slot:head(email)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(external_id)="data">{{ $t(data.label) }}</template>

            <!--
            <template v-slot:head(selected)>
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid">
                <input type="checkbox" @click.stop @change="selectAll" v-model="checkAll" />
                <span></span>
              </label>
            </template>
            <template v-slot:cell(selected)="data">
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid">
                <input type="checkbox" @click.stop :value="data.item.eid" v-model="selected" />
                <span></span>
              </label>
            </template>
            -->

            <template v-slot:cell(etenant_id)="data">
              <span v-if="data.value.to">
                <router-link :to="`/tenants/${data.value.to}`">{{ data.value.name }}</router-link>
              </span>
              <span v-else>{{ data.value.name }}</span>
            </template>
            
            <template v-slot:cell(eshop_id)="data">
              <span v-if="data.value.to">
                <router-link :to="`/shops/${data.value.to}`">{{ data.value.name }}</router-link>
              </span>
              <span v-else>{{ data.value.name }}</span>
            </template>

          </b-table>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <!--
                <BulkActionSelect
                  v-model="bulkAction"
                  :options="bulkActionOptions"
                  variant="light"
                  class="mr-2"
                  size="sm"
                  v-if="selected.length"
                />
                <b-button
                  @click.stop="applySelected()"
                  size="sm"
                  class="mr-2 refresh"
                  variant="light"
                  v-if="selected.length"
                  :disabled="!bulkAction"
                >{{$t('Apply')}}</b-button>
                <span class="pagination-sep" v-if="selected.length"></span>
                -->
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{(currentPage-1) * perPage + 1}}</span>
                    <span slot="end">{{currentPage * perPage}}</span>
                    <span slot="total">{{totalRows}}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="$root.$emit('bv::refresh::table', 'third-party-players-table')"
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import PaginationSelect from "@/components/PaginationSelect";
import tableMixin from "@/shared/mixins/table.mixin";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";
// import BulkActionSelect from "@/components/BulkActionSelect";

export default {
  name: "thirdPartyPlayers",
  components: {
    PaginationSelect,
    DropdownColumns,
    // BulkActionSelect,
    TableFilters
  },
  mixins: [tableMixin],
  data: function() {
    return {
      tableName: "thirdPartyPlayersTable",

      /*
      bulkAction: null,
      bulkActionOptions: [
        {
          text: "Blacklist Players",
          field: "blacklisted",
          value: true
        },
        {
          text: "Allow Players",
          field: "blacklisted",
          value: false
        }
      ],
      */

      filterOptions: [
        {
          field: "tenant_id",
          multiple: false,
          placeholder: "Tenant",
          trackBy: "eid",
          label: "brand_name",
          translate: false,
          store: "tenants",
          options: [],
          selected: []
        },
        {
          field: "shop_ids",
          multiple: true,
          placeholder: "Shops",
          trackBy: "eid",
          label: "name",
          store: "shops",
          translate: false,
          options: [],
          selected: []
        },
      ],


      isBusy: false,
      sortBy: "name",
      sortDesc: false,
      fields: [
        /*
        {
          key: "selected",
          selected: false,
          ignore: true,
          class: "mw-select",
          dpIgnore: true
        },
        */
        {
          key: "eid",
          label: "Id",
          sortable: false,
          class: "d-none",
          ignore: true
        },
        {
          key: "etenant_id",
          label: "Tenant",
          sortable: true,
          class: ""
        },
        {
          key: "eshop_id",
          label: "Shop",
          sortable: true,
          class: ""
        },
        { key: "name", sortable: true, class: "" },
        { key: "surname", sortable: true, class: "" },
        { key: "email", sortable: true, class: "" },
        { key: "external_id", sortable: true, class: "" },
        // { key: "cnp", label: "CNP", sortable: true, class: "" },
        // { key: "blacklisted", sortable: true, ignore: true, class: "" },
        /*
        {
          key: "app_id",
          label: "App Used",
          sortable: true,
          ignore: true,
          class: "d-none"
        },
        {
          key: "euser_id",
          label: "Added by",
          sortable: true,
          ignore: true,
          class: ""
        }
        */
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,

      // checkAll: false,
      // selected: [],
      // copy: null,

      // addLabel: "Add third party player"
    };
  },
  /*
  watch: {
    selected(val) {
      if (val.length != this.copy.length) {
        this.checkAll = false;
      }
    }
  },
  */
  methods: {

    refresh() {
      this.$root.$emit("bv::refresh::table", "third-party-players-table");
    },
    /*
    selectAll() {
      this.selected = [];
      this.copy.forEach(item => {
        if (this.checkAll) {
          this.selected.push(item.eid);
        }
      });
    },

    applySelected() {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const bulkData = {
        field: this.bulkAction.field,
        value: this.bulkAction.value,
        ids: this.selected
      };

      this.$store.dispatch("player/bulkAction", bulkData).finally(() => {
        loading.close();
        this.allSelected = false;
        this.selected = [];
        this.refresh();
      });
    },
    */
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      paginationData.likeValues = [];
      paginationData.likeFields = [];

      if (this.sortBy) {
        let sortBy = this.sortBy;
        if (sortBy == "etenant_id") sortBy = "tenant_id";
        if (sortBy == "eshop_id") sortBy = "shop_id";
        paginationData.sortBy = [sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach(item => {
        if (item.selected.length) {
          exactFields.push(item.field);
          if (item.trackBy) {
            const tmp = [];
            item.selected.forEach(el => {
              tmp.push(el[item.trackBy]);
            });
            exactValues.push(tmp);
          } else {
            exactValues.push(item.selected);
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      const tenantByID = this.$store.getters["cache/tenantByID"];
      const shopByID = this.$store.getters["cache/shopByID"];

      Promise.all([
        this.$store.dispatch("cache/fetch", "tenants").catch(e => e),
        this.$store.dispatch("cache/fetch", "shops").catch(e => e),
      ]).finally(() => {

        this.$store
          .dispatch("thirdPartyPlayer/fetch", paginationData)
          .then(resp => {
            this.totalRows = resp.data.total;

            resp.data.rows.forEach((item, index) => {

              if (item.etenant_id) {
                const data = tenantByID(item.etenant_id);
                if (data) {
                  item.etenant_id = {
                    to: item.etenant_id,
                    name: data.brand_name
                  };
                } else {
                  item.etenant_id = {
                    to: null,
                    name: item.etenant_id
                  };
                }
              } else {
                  item.etenant_id = {
                    to: null,
                    name: ""
                  };
              }

              if (item.eshop_id) {
                const data = shopByID(item.eshop_id);
                if (data) {
                  item.eshop_id = {
                    to: item.eshop_id,
                    name: data.name
                  };
                } else {
                  item.eshop_id = {
                    to: null,
                    name: item.eshop_id
                  };
                }
              } else {
                  item.eshop_id = {
                    to: null,
                    name: ""
                  };
              }

              /*
              if (item.blacklisted) {
                resp.data.rows[index]["_cellVariants"] = {
                  blacklisted: "danger"
                };
              }

              if (item.euser_id) {
                const data = userByID(item.euser_id);
                if (data) {
                  item.euser_id = {
                    to: item.euser_id,
                    name: data.username
                  };
                } else {
                  item.euser_id = {
                    to: null,
                    name: item.euser_id
                  };
                }
              }

              if (item.app_id) {
                const data = terminalByAppID(item.app_id);
                if (data) {
                  item.app_id = {
                    to: data.eshop_id,
                    name: item.app_id
                  };
                } else {
                  item.app_id = {
                    to: null,
                    name: item.app_id
                  };
                }
              }
              */

            });

            callback(resp.data.rows);
          })
          .catch(err => {
            this.$bvToast.toast(
              this.$t(err.message),
              errorConf(this.$t("Error"))
            );
            this.totalRows = 0;
            callback([]);
          })
          .finally(() => {
            loading.close();
          });
      });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    rowClicked(item, index, event) {
      this.$router.push("/third-party-players/" + item.eid);
    },
    redirect() {
      this.$router.push("/third-party-players/0");
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


